import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { SpinnerService } from 'shared-components';
import { Message } from 'projects/shared-components/src/lib/models/message.model';
import { UsuariosService } from '../../../services/usuarios.service';

@Component({
  selector: 'app-delete-role',
  templateUrl: './delete-role.component.html'
})
export class DeleteRoleComponent implements OnInit {

  public deleteRolesForm: UntypedFormGroup;
  public showError = false;
  public mensajes = new Array<Message>();

  public roles = [];

  @Input() userName: string;
  @Input() userRoles: any;

  @Output() mensaje = new EventEmitter<string>();
  @Output() refreshRoles = new EventEmitter<boolean>();

  constructor(
    private _fb: UntypedFormBuilder,
    private readonly _spinnerService: SpinnerService,
    private readonly _usuariosService: UsuariosService
  ) { }

  ngOnInit() {
    this.deleteRolesForm = this._fb.group({
      roleName: ['', Validators.required]
    });

    this.userRoles.forEach(rol => {
      this.roles.push({id: rol.applicationRoleId, des: rol.roleName});
    });
  }

  public deleteUserRole() {
    this.showError = this.deleteRolesForm.invalid;
    if (this.deleteRolesForm.valid) {
      this._spinnerService.showSpinner();
      this.mensajes = [];
      let filters = {
        userName: this.userName,
        roleName: this.deleteRolesForm.get('roleName').value.des
      }
      this._usuariosService.deleteUserRole(filters).toPromise().finally(() => {
        this._spinnerService.hideSpinner();
      }).then(
        (resp) => {
          this.refreshRoles.emit(true);
          this.mensaje.emit('global.success.itemDeleted');
        },
        (error) => {
          this.showError = true;
          this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
        }
      );
    } else {
      this.showError = true;
      this.mensajes.push({ class: 'error', message: 'usuarios.general.modalDeleteRole.noRole' });
    }
  }

  public closeDeleteRoleModal() {
    this.refreshRoles.emit(false);
  }

}
